<template>
  <div class="content">
    <div style="height: 70px;">
      <HomeHeader :forOrder="true"></HomeHeader>
    </div>
    <div class="order_datail_box">
      <div></div>
      <div>
        <p style="font-family:'苹方';font-size: 14px;margin: 30px 0;">
          <span style="color:#1e50f0">酒店账单明细</span>
          / 酒店账单详情
        </p>
        <div class="order_info_box">
          <div class="order_info_item order_num">
            <span style="font-family: '苹方'">
              账单批次号：{{ form.batchNumber }}
              <span style="font-size: 11px;font-weight: normal;color: #34664c;background-color: #a5eebf;padding: 1px 8px;border-radius: 100px">
                <i class="el-icon-circle-check" />
                已结算
              </span>
            </span>
            <span style="font-family: '苹方'">
              总价
              <span style="color: #1e50f0;">CNY {{ billDetail.actualPrice }}</span>
            </span>
          </div>
          <div class="order_info_item">结算维度：{{ billDetail.settlementType }}</div>
          <div class="order_info_item">
            结算周期：{{ billDetail.checkTime && billDetail.checkTime.length ? billDetail.checkTime[0] + ' ~ ' + billDetail.checkTime[1] : ''}}
          </div>
          <div class="order_info_item">结算时间：{{ billDetail.createDate }}</div>
        </div>

        <el-table :data="orders" style="width: 100%; margin-top: 20px; font-size: 12px"
                  max-height="570px" @sort-change="sortChange" v-loading="isLoading">
          <el-table-column label="科坦订单号" prop="outerId" width="185"></el-table-column>
          <el-table-column label="贵司订单号" prop="customerOrderId" width="185"></el-table-column>
          <el-table-column label="支付方式">
            <template slot-scope="scope">
              信用额度支付
            </template>
          </el-table-column>
          <el-table-column label="入离日期">
            <template slot-scope="scope">
              <p>{{ scope.row.checkIn }}</p>
              <p>{{ scope.row.checkOut }}</p>
            </template>
          </el-table-column>
          <el-table-column label="订单状态">
            <template slot-scope="scope">
              <div style="display: flex; align-items: center;column-gap: 5px">
                <div :style="'background-color:' + getStatusColor(scope.row.orderStatus)" class="dot"></div>
                <span :style="'color:' + getStatusColor(scope.row.orderStatus)">{{ getOrderStatus(scope.row.orderStatus) }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="下单时间" prop="orderTime" width="145" sortable="custom">
            <template slot-scope="scope">
              {{ scope.row.orderTime ? scope.row.orderTime.replace('T', ' ') : '' }}
            </template>
          </el-table-column>
          <el-table-column label="订单本次结算金额">
            <template slot-scope="scope">
              {{ scope.row.settPrice ? `${scope.row.currency && currencyMap[scope.row.currency] ? currencyMap[scope.row.currency] : '￥'} ${scope.row.settPrice / 100}` : '0' }}
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination :current-page="form.pageCurrent" :page-size="form.pageSize"
                         layout="total, prev, pager, next, jumper" :total="form.total" :hide-on-single-page="true"
                         @current-change="pageChange" style="margin: auto;">
          </el-pagination>
        </div>
      </div>
      <div></div>
    </div>
  </div>
</template>

<script>
import HomeHeader from '../../booking/components/HomeHeader.vue'

export default {
  name: 'HotelBillDetail',
  components: {HomeHeader},
  data () {
    return {
      form: {
        batchNumber: '',
        pageSize: 20,
        pageCurrent: 1,
        total: 0
      },
      billDetail: {},
      partnerInfo: {},
      headers: {},
      orders: [],
      orderStatusOptions: [
        { id: 0, name: this.$t('center.all'), value: -1 },
        { id: 1, name: this.$t('center.Processing'), value: [0, 1, 4, 5, 11], color: '#d6b858' },
        { id: 2, name: this.$t('center.Confirmed'), value: [2, 13, 14], color: '#1e50f0' },
        { id: 3, name: this.$t('center.Canceled'), value: [3, 15], color: '#909399' },
        { id: 4, name: this.$t('center.Full_house'), value: [12], color: 'red' },
        { id: 5, name: this.$t('center.Order_Close'), value: [16], color: 'red' }
      ],
      isLoading: false,
      currencyMap: {
        'CNY': '￥',
        'USD': '$'
      }
    }
  },
  mounted () {
    this.partnerInfo = JSON.parse(this.$common.isLogin())
    this.headers = {accessToken: this.partnerInfo.token}
    if (!this.partnerInfo) {
      this.$message.warning('请登录后再查看')
      this.$router.push('/login')
    }
    let info = window.atob(this.$route.query.detail)
    this.billDetail = JSON.parse(decodeURIComponent(info))
    this.form.batchNumber = this.billDetail.batchNumber
    this.searchChlBatchBillDetail(true)
  },
  methods: {
    async searchChlBatchBillDetail (flag) {
      if (flag) {
        this.form.pageCurrent = 1
      }
      this.isLoading = true
      const {data: result} = await this.$http.post('/b2b/searchChlBatchBillDetail', this.form, {headers: this.headers})
      this.isLoading = false
      if (result.code !== 200) return this.$message.error(result.message)
      this.orders = result.data.data
      if (flag) {
        this.form.total = result.data.total
      }
    },
    sortChange (e) {
      if (!e.order) {
        this.$delete(this.form, 'sortType')
      } else {
        let sortType = e.order === 'ascending' ? 1 : e.order === 'descending' ? 2 : null
        this.$set(this.form, 'sortType', sortType)
      }
      this.searchChlBatchBillDetail(true)
    },
    pageChange (e) {
      this.form.pageCurrent = e
      this.searchChlBatchBillDetail()
    },
    /**
     * 0, 1, 4, 5, 11：处理中
     * 2, 13, 14：已确认
     * 3, 15：已取消
     * 12：满房
     * 16：订单关闭
     */
    getOrderStatus (status) {
      for (let i = 1; i < this.orderStatusOptions.length; i++) {
        let item = this.orderStatusOptions[i]
        if (item.value.indexOf(status) !== -1) {
          return item.name
        }
      }
    },
    getStatusColor (val) {
      if (!val) {
        return '#ffffff'
      }
      for (let i = 1; i < this.orderStatusOptions.length; i++) {
        let item = this.orderStatusOptions[i]
        if (item.value.indexOf(val) !== -1) {
          return item.color
        }
      }
      return '#ffffff'
    }
  }
}
</script>

<style scoped lang="less">
.content {
  background-color: #f5f7fa;
  min-height: 100vh;
}


.order_datail_box {
  display: grid;
  grid-template-columns: 10% 1fr 10%;
  padding-bottom: 30px;

  .order_info_box,
  .hotel_info_box {
    padding: 15px;
    background-color: #fff;
    margin-bottom: 30px;

    display: grid;
    grid-template-columns: repeat(3, auto);

    .order_num {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      font-weight: bold;
      background-color: #edeff8;
    }

    .order_info_item {
      height: 45px;
      line-height: 45px;
      font-family: '苹方';
      padding: 0 10px;
      border: 1px solid #e8ebef;
      border-collapse: collapse;
      margin-top: -1px;
      margin-left: -1px;
    }

    .confirm_btn_box {
      grid-column-start: 3;
      grid-column-end: 4;
      grid-row-start: 2;
      grid-row-end: 4;
      border-right: 1px solid #e8ebef;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .order_num,
    .order_status {
      grid-column-start: 1;
      grid-column-end: 4;
    }

    .img_box {
      display: flex;
      column-gap: 15px;
      grid-column-start: 1;
      grid-column-end: 4;
      height: 115px;
      padding: 15px 10px;

      .img__content {
        display: flex;
        column-gap: 15px;
      }
    }
  }

  .attention_item_box {
    background-color: #fff;
    padding: 15px;
    margin-bottom: 30px;

    .attention_item {
      display: grid;
      grid-template-columns: 100px 50%;
      grid-template-rows: repeat(3, auto);
      grid-gap: 20px;
      line-height: 20px;

      .attention_item_title {
        color: #a3a3a3;
      }
    }
  }

  .box_title {
    height: 45px;
    line-height: 45px;
    background-color: #edeff8;
    padding: 0 10px;
    font-size: 14px;
    font-weight: bold;
    font-family: '苹方';
    border-bottom: 1px solid #e8ebef;
  }

  .work_order_content {
    font-family: '苹方';
    background-color: #fff;
    padding: 15px;

    .item_box {
      border: 1px solid #e8ebef;
      border-top: none;
      padding: 15px;

      .work_order_item {
        border: 1px solid #e8ebef;

        &:not(:last-child) {
          margin-bottom: 15px;
        }

        .item_header {
          display: flex;
          padding: 15px 10px;
          align-items: center;
          position: relative;
          column-gap: 25px;

          &::before {
            content: "";
            display: block;
            width: 98%;
            height: 1px;
            background: #e8ebef;
            position: absolute;
            bottom: 0;
            left: .5%;
          }
        }

        .status {
          padding: 3px 10px;
          color: #fff;
          border-radius: 50px;
        }

        .item_content {
          transition: max-height .2s ease-in-out;

          .item_content_title {
            font-size: 14px;
            font-weight: bold;
            font-family: '苹方';
            position: relative;
            padding-bottom: 10px;
            margin-bottom: 10px;

            &::before {
              content: "";
              display: block;
              width: 40px;
              height: 2px;
              position: absolute;
              background-color: #1e50f0;
              bottom: 0;
              left: 8px;
            }
          }

          .detail {
            display: flex;
            padding-top: 10px;
            column-gap: 20px;
            height: 350px;
            overflow: auto;
            scroll-behavior: smooth;

            .msg_deatil {
              border-bottom: 1px solid #e8ebef;
              padding-bottom: 8px;
              padding-right: 20px;
              font-size: 13px;
              font-family: '苹方';
              line-height: 20px;
            }
          }

          .reply_box {
            margin-top: 20px;
            flex-basis: 100%;
            position: relative;

            .send_btn {
              position: absolute;
              bottom: 4px;
              right: 6px;
            }
          }

          /deep/ .el-textarea .el-input__count {
            right: 80px;
            bottom: 12px;
          }

          /deep/ .el-upload-list__item-name {
            transition: none !important;
            -webkit-transition: nonne !important;
          }

          /deep/ .el-upload-list__item {
            transition: none !important;
            -webkit-transition: nonne !important;
          }

        }

        .item_content.close {
          max-height: 0;
          overflow: hidden;
        }

        .item_content.open {
          padding: 15px;
          min-height: 560px;
          overflow: hidden;
        }
      }
    }


  }

  /deep/ .el-button--primary:hover {
    background-color: #1e50f0;
  }

  /deep/ .el-button--primary.is-disabled:hover {
    background-color: #C0C4CC;
  }

  /deep/ .el-table th {
    background-color: #edeff8 !important;
  }

  .pagination {
    margin: 35px;
    position: relative;

    /deep/ .el-pagination {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .dot {
    border-radius: 100px;
    height: 4px;
    width: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/order/components/HotelBillDetail.vue